import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class Fee {

  @JsonProperty()
  originCode: string | undefined;

  @JsonProperty()
  code: string | undefined;

  @JsonProperty()
  description: string | undefined;

  @JsonProperty()
  value: number;

  @JsonProperty()
  currency: string | undefined;

  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

}
